export const MSISDN = {
  MIN_LENGTH: 9,
  EMPTY_MSISDN: 0
} as const;

export const ITEM = {
  DEFAULT_VALUE: 0,
  START_INDEX: 0,
  INITIAL_ITEMS: 8,
  EMPTY_LENGTH: 0,
  SINGLE_EMISSION:1
} as const;
